import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Title } from "react-admin";
import { useDI } from "@/infrastructure/di/useDI";
import { JobTrackMap } from "./JobTrackMap";

const EMPTY: GeoJSON.FeatureCollection = {
  type: "FeatureCollection",
  features: [],
};

export function JobTrackMapPage() {
  const { id } = useParams();
  const { jobTrackService } = useDI();

  const [geo, setGeo] = useState<GeoJSON.FeatureCollection>(EMPTY);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;

    (async () => {
      setLoading(true);
      setErr(null);
      try {
        const data = await jobTrackService.getTrackGeoJson(id);
        if (!cancelled) setGeo(data ?? EMPTY);
      } catch (e: any) {
        if (!cancelled) setErr(e?.message ?? String(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id, jobTrackService]);

  return (
    <div
      style={{
        height: "calc(100vh - 64px)",
        display: "flex",
        flexDirection: "column",
        gap: 12,
        position: "relative",
      }}
    >
      <Title title="Job Track" />

      <div style={{ flex: 1, minHeight: 400 }}>
        <JobTrackMap geo={geo} />
      </div>

      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
            background: "rgba(255,255,255,0.6)",
            pointerEvents: "none",
          }}
        >
          Loading track…
        </div>
      )}

      {err && (
        <div
          style={{
            position: "absolute",
            left: 12,
            bottom: 12,
            padding: 8,
            borderRadius: 8,
            background: "white",
          }}
        >
          {err}
        </div>
      )}
    </div>
  );
}
